import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { InputBox } from '../../../../../../components';
import Layout from '../../Layout';
import { CategoryLevels, LevelsType } from '../lib';

import { MdWarning } from 'react-icons/md';
import { ObjetiveMargin } from '../lib/types';
import { SetupIPACategoryLevelsCategoryLevelsMessage } from './SetupIPACategoryLevelsCategoryLevelsMessage';
import styles from './SetupIPACategoryLevelsCategoryMargin.module.scss';

const { Section, Title, Subtitle } = Layout;
const { Error, Select } = InputBox;

interface SetupIPACategoryLevelsCategoryMarginProps {
  form: UseFormReturn<CategoryLevels>;
  segments: LevelsType[];
  queryObjectiveMargin: ObjetiveMargin | undefined;
}

export const SetupIPACategoryLevelsCategoryMargin = ({ form, segments, queryObjectiveMargin }: SetupIPACategoryLevelsCategoryMarginProps) => {
  const objectiveMarginSaved = queryObjectiveMargin?.field;
  const selectedValue = form.watch('objectiveMargin');

  const showWarning = selectedValue && objectiveMarginSaved && objectiveMarginSaved !== selectedValue?.field;
  return (
    <Section.Root>
      <Section.Header>
        <Title>Margem objetiva</Title>
        <Subtitle>Defina qual o nível de categoria será usado para a definição de margem objetiva</Subtitle>
      </Section.Header>

      <Section.Content>
        <Controller
          control={form.control}
          name="objectiveMargin"
          render={({ field, fieldState: { error } }) => {
            return (
              <div>
                <InputBox className={styles.container}>
                  <Select
                    data={segments}
                    onChange={selectedOption => {
                      if (typeof selectedOption === 'string') {
                        const selected = segments.find(option => option.field === selectedOption);
                        field.onChange(selected || null);
                      } else {
                        field.onChange(selectedOption);
                      }
                    }}
                    value={field.value?.field}
                    searchable={false}
                    cleanable={false}
                    defaultValue={segments[2]?.name}
                  />
                  <Error message={error?.message} />
                </InputBox>
              </div>
            );
          }}
        />
        {showWarning && (
          <SetupIPACategoryLevelsCategoryLevelsMessage>
            <MdWarning size={20} color="#FFB800" />
            <div>
              <strong>Atenção!</strong>
              <p>
                Ao alterar o nível da Margem Objetiva, todos os cadastros existentes vinculados ao nível anterior serão removidos. Será necessário refazê-los
                com base no novo nível selecionado.
              </p>
            </div>
          </SetupIPACategoryLevelsCategoryLevelsMessage>
        )}
      </Section.Content>
    </Section.Root>
  );
};
